module.exports = __webpack_public_path__ + "static/img/pic4.d50c168.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slideShow/pic4.jpg
// module id = jD1R
// module chunks = 0